// eslint-disable-next-line @typescript-eslint/no-require-imports
module.exports = require(`../../../redirects-list.json`)
